import * as React from 'react';

import { MomentInput } from 'moment';
import { formatDateTime, DefaultDateFormat, DefaultTimeFormat, DefaultDateTimeFormat } from 'util/Time';

interface TimeProps {
	time?: MomentInput;
	format?: string;
}

/**
 * A simple component which formats renders a specified date/time in plaintext, localized to the server's time zone.
 *
 * @class FormattedDateTime
 * @extends {(React.PureComponent<TimeProps>)}
 */
export class FormattedDateTime extends React.PureComponent<TimeProps> {
	public render() {
		return <>{formatDateTime(this.props.time, this.props.format || DefaultDateTimeFormat)}</>;
	}
}

/**
 * A simple component which formats renders a specified date in plaintext, localized to the server's time zone.
 *
 * @class FormattedDate
 * @extends {(React.PureComponent<TimeProps>)}
 */
export class FormattedDate extends React.PureComponent<TimeProps> {
	public render() {
		return <>{formatDateTime(this.props.time, this.props.format || DefaultDateFormat)}</>;
	}
}

/**
 * A simple component which formats renders a specified time in plaintext, localized to the server's time zone.
 *
 * @class FormattedTime
 * @extends {(React.PureComponent<TimeProps>)}
 */
export class FormattedTime extends React.PureComponent<TimeProps> {
	public render() {
		return <>{formatDateTime(this.props.time, this.props.format || DefaultTimeFormat)}</>;
	}
}
